(function() {
'use strict';

angular
    .module('TR')
    .controller('SelectedFlight', SelectedFlight);

function SelectedFlight($routeParams,
                        $scope,
                        basketService,
                        urlStoreService,
                        $location,
                        resourceService,
                        basketStore,
                        broker,
                        flightSearch,
                        flightDetail,
                        occupancyService,
                        preferences,
                        tripService,
                        analytics,
                        $window) {
    const sf = this;

    const stop = $scope.$watch(() => $window.abDeal173, v => {
            if (v) {
                sf.reloadingFlight = v;
                stop();
            }
        }
    );

    if (!$routeParams.tripId) {
        return;
    }

    preferences.get('priceMode').then(function(p) {
        sf.priceMode = p;
    });
    sf.addingFlight = basketStore.addingFlight();
    sf.changeFlight = changeFlight;
    sf.keepFlight = keepFlight;
    sf.flightImage = flightImage;
    sf.noFlight = false;

    tripService.usePackageRates().then(packagePrice => {
        sf.detailOpen = (TRPCONFIG.Domain.isAgentMode && !TRPCONFIG.Domain.PriceBucketFilterEnabled)
            || TRPCONFIG.Domain.FlightDetailsExpanded
            || TRPCONFIG.Domain.BestFitFlightSelection
            || packagePrice;
        sf.isPackagePrice = packagePrice;
    });

    tripService.getTrip($routeParams.tripId).then(function(trip) {
        const { FlightsRequest } = trip;
        const SelectedFlight = FlightsRequest && FlightsRequest.SelectedFlight;
        const PriorityForPreSelection = SelectedFlight && SelectedFlight.PriorityForPreSelection;
        sf.priorityForPreSelection = PriorityForPreSelection;
        sf.isMultiDestHoliday = trip && trip.TripType === tripService.tripTypes.MultiDestHoliday;
        basketStore.totalCost(trip.BasketId).then(res => sf.totalCost = res);

        if (sf.isMultiDestHoliday) {
            sf.detailOpen = true;
        }
        basketService.getFlight(trip.BasketId)
            .then(flight => {
                if (flight) {
                    sf.flight = flight.Details.Itinerary;
                    sf.flightRoutes = getFlightRoutes();
                    sf.flight.DepositAllowed = !_.isEmpty(flight.FuturePayments);
                    _flightCost(trip);
                    flightSearch.setBags(trip, sf.flight);
                    sf.oneWayOnly = sf.flight.Legs.length === 1;
                } else {
                    sf.noFlight = true;
                }
            });

        //we need to listen out for the flight to be ready here as well as requesting it directly because
        //it might be in the process of being added to the basket
        broker.subscribe('SelectedFlight', 'flightAddedToBasket', function(f) {
            sf.flight = f.data.Details.Itinerary;
            sf.flightRoutes = getFlightRoutes();
            _flightCost(trip);
            flightSearch.setBags(trip, sf.flight);
        });
        broker.subscribe('SelectedFlight', 'basketUpdated', _.debounce(function() {
            _flightCost(trip);
            flightSearch.setBags(trip, sf.flight);
        }, 100));
        broker.subscribe('SelectedFlight', 'priceModeChanged', function(ev) {
            sf.priceMode = ev.data;
        });

        $scope.$on('$destroy', function() {
            broker.unsubscribe('SelectedFlight');
        });
    });

    function getFlightRoutes() {
        let routes = [sf.flight.Legs[0].DepartureAirport.Code, sf.flight.Legs[0].ArrivalAirport.Code];
        if (TRPCONFIG.Rtl) {
            routes = _.reverse(routes);
        }
        return {
            Departure: routes[0],
            Arrival: routes[1]
        };
    }

    function changeFlight() {
        analytics.track('mixpanel', 'ChangeFlightClick');
        flightSearch.resetPageIndex();
        basketService.changeJourneyUrl(10);

        if (sf.isMultiDestHoliday) {
            $scope.$emit('block', {
                title: resourceService.get('SEARCHINGFLIGHTS'),
                subtitle: resourceService.get('THISMAYTAKE'),
                loadingScreenStyle: 'default-searchUnitCtrl'
            });
        }
    }

    function keepFlight() {
        const opts = {
            bags: sf.flight.bags,
            maxbags: occupancyService.getNumberOfNonInfantPassengers() || 1
        };
        const previousURL = urlStoreService.getPreviousURL();
        const applicablePathRegEx = '(/|/holidays/|/hotels)(flights|hotels|options|book|([0-9a-fA-F-]+))/[0-9a-fA-F-]+';
        let cameFromWrongPath = urlStoreService.cameFromWrongPath(applicablePathRegEx);

        // if trip id for some reason was changes we should remove selected hotel and sand user to the usual flow
        if (urlStoreService.isTripIdChanged()) {
            cameFromWrongPath = true;
            sessionStorage.removeItem('preselectedHotelData');
        }

        // if user copied url from other browser previousURL will be empty and we need to handle this case
        // and we use selectFlight, it our default method
        if (!cameFromWrongPath) {
            if (previousURL === null) {
                basketService.selectFlight(sf.flight, $routeParams.tripId, opts, $routeParams);
            } else if (basketService.isFlightPreselected()) {
            // we have the list of destination where flight preselected automatically and user have change flight page with keep flight button
            // for this case we hawe _keepPreselectedFlight method which have additional check
                _keepPreselectedFlight(opts, previousURL);
            } else if (TRPCONFIG.Domain2.ShowSelectedFlightV2) {
                _keepManuallySelectedFlight(opts, previousURL);
            } else {
            // just check if all expression was false we use default behaviour
                basketService.selectFlight(sf.flight, $routeParams.tripId, opts, $routeParams);
            }
        } else {
            basketService.selectFlight(sf.flight, $routeParams.tripId, opts, $routeParams);
        }
    }

    function _keepPreselectedFlight(opts, previousURL) {
        const isHotelSelected = sessionStorage.getItem('preselectedHotelData') !== null;
        let preSelectedFlight = sessionStorage.getItem('storeSelectedFlight');
        const cameFromChooseRoomPage = previousURL.match('(holidays/)[0-9a-fA-F-]+(/)[0-9]+') !== null;
        preSelectedFlight = preSelectedFlight !== null ? JSON.parse(preSelectedFlight) : null;
        if (isHotelSelected && preSelectedFlight !== null && preSelectedFlight.FlightId === sf.flight.FlightId && cameFromChooseRoomPage) {
            basketService.selectFlight(sf.flight, $routeParams.tripId, opts, $routeParams);
        } else {
            $location.path(previousURL);
        }
    }

    function _keepManuallySelectedFlight(opts, previousURL) {
        if (previousURL !== null) {
            $location.path(previousURL);
        } else {
            basketService.selectFlight(sf.flight, $routeParams.tripId, opts, $routeParams);
        }
    }

    function flightImage(fallback) {
        if (!sf.flight) {
            return `${fallback} ...`;
        }
        let count = 0;
        let images = '';
        const img = '<img src="/build/img/Airline/Small/{0}" />';
        sf.flight.AirlineImages.forEach(function(i) {
            if (count < 3) {
                images += String.format(img, i);
                count++;
            }
        });
        return images;
    }

    function _flightCost(trip) {
        basketStore.flightCost(trip.BasketId).then(function(c) {
            const numPassengers = occupancyService.getNumberOfNonInfantPassengers() || 1;
            sf.totalFlightCost = c;
            sf.flightCostPerPerson = c / numPassengers;
            sf.addingFlight = false;
        });
        basketStore.totalCost(trip.BasketId).then(res => sf.totalCost = res);
    }

    sf.toggleDetail = function() {
        sf.detailOpen = !sf.detailOpen;
    };

    sf.showDetails = function() {
        broker.publish('showModalFlightDetails', { flight: sf.flight });
    };
}
})();
